import React from "react";
import styled from "styled-components/macro";
import loading from "./loading.gif";

const CenterImg = styled.img`
  height: fit-content;
`;

export default () => <CenterImg alt="loading animation" src={loading} />;
